import { CustomInterventionItem } from "../../../types";
import { InterventionStep } from "./InterventionStep";

type InterventionPreviewProps = {
  intervention: CustomInterventionItem;
  opaque?: boolean;
};

export const InterventionPreview = ({ intervention, opaque }: InterventionPreviewProps) => {
  return (
    <div className={"mt-2 flex w-full flex-col  "}>
      {intervention.steps!.map((step) => (
        <InterventionStep opaque={opaque} key={step.id} step={step} />
      ))}
    </div>
  );
};
